export type Lang = "en" | "it";

export const defaultLang = "en";
